import React from 'react'
// import Slider from '@material-tailwind/react/components/Slider';
import CustomSlider from './CustomSlider'

interface PriceRangeSliderProps {
  min?: number
  max?: number
  payRangeMin?: number
  // eslint-disable-next-line no-unused-vars
  onChange: (value: number) => void
}

export const PriceRangeSlider = ({
  min = 0,
  max = 200,
  payRangeMin,
  onChange,
}: PriceRangeSliderProps) => {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = Number(event.target.value)
    onChange(value)
  }

  return (
    <div className="flex flex-col items-center justify-center w-full space-y-8 text-night">
      <div className="w-[300px] px-4 flex items-center justify-between gap-x-5">
        <DisplayValue value={payRangeMin || min} />
        <div className="flex-1 mt-1 border border-dashed border-neutral-500" />
        <DisplayValue value={max} />
      </div>

      <div className="w-96">
        {/* <Slider
                    color='blue'
                    value={payRangeMin || min}
                    min={min}
                    max={max / 2}
                    aria-valuemax={max}
                    onChange={(event) => handleChange(event)}
                /> */}
        <CustomSlider
          color="blue"
          value={payRangeMin || min}
          min={min}
          max={max}
          aria-valuemax={max}
          onChange={(event) => handleChange(event)}
        />
      </div>
    </div>
  )
}

const DisplayValue = ({ value }: { value: number }) => (
  <p className="text-xl font-semibold text-neutral-100">
    {Math.round(value)}K€
  </p>
)
